import React from 'react'
import { useRouter } from 'next/router'

import { oSeriesPages } from 'types/oSeriesPages'

import Loader from 'components/o_series/common/Loader'
import useCheckout from 'utils/hooks/useCheckout'

type Props = {
  children: React.ReactNode
}

function EnsureCheckoutDataLoaded({ children }: Props): JSX.Element {
  const router = useRouter()
  const { isLoading, offer } = useCheckout()

  if (isLoading) {
    return (
      <div className="pt-32 px-7 max-w-md mx-auto">
        <Loader />
      </div>
    )
  }

  if (!offer) {
    router.replace(
      `/${router.locale}/${router.query.pipe}/${oSeriesPages.landing}`
    )

    return null
  }

  return <>{children}</>
}

export default EnsureCheckoutDataLoaded
